import { RmaSearchType, RmasType } from 'b2b-common/core/account/api/rma';
import {
  CLEAR_ACCOUNT_RMAS,
  FETCH_RMAS,
  FETCH_RMAS_FULFILLED,
  FETCH_RMAS_REJECTED,
  SEARCH_RMAS,
  SEARCH_RMAS_FULFILLED,
  SEARCH_RMAS_REJECTED,
} from './actionTypes';
import {
  ClearAccountRmasAction,
  FetchRmasAction,
  FetchRmasFulfilledAction,
  FetchRmasRejectedAction,
  SearchRmasAction,
  SearchRmasFulfilledAction,
  SearchRmasRejectedAction,
} from './types';

export const fetchRmas = (pageSize: number, startItem: number): FetchRmasAction => ({
  type: FETCH_RMAS,
  payload: {
    startItem,
    pageSize,
  },
});

export const fetchRmasFulfilled = (response: RmasType): FetchRmasFulfilledAction => ({
  type: FETCH_RMAS_FULFILLED,
  payload: {
    data: response,
  },
});
export const fetchRmasRejected = (error: ErrorType): FetchRmasRejectedAction => ({
  type: FETCH_RMAS_REJECTED,
  payload: {
    error,
  },
});
export const clearAccountRmas = (): ClearAccountRmasAction => ({
  type: CLEAR_ACCOUNT_RMAS,
});
export const searchRmas = (query: string): SearchRmasAction => ({
  type: SEARCH_RMAS,
  payload: {
    query,
  },
});
export const searchRmasFulfilled = (response: RmaSearchType): SearchRmasFulfilledAction => ({
  type: SEARCH_RMAS_FULFILLED,
  payload: {
    data: response,
  },
});
export const searchRmasRejected = (error: ErrorType): SearchRmasRejectedAction => ({
  type: SEARCH_RMAS_REJECTED,
  payload: {
    error,
  },
});
